import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GA4_ID = process.env.REACT_APP_GA4_ID;

let ga4Loaded = false;

function loadGA4() {
  if (ga4Loaded || !GA4_ID || typeof document === "undefined") return;
  ga4Loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID, { send_page_view: true });
}

export function initAnalytics() {
  loadGA4();
}

export function trackEvent(event, metadata = {}) {
  try {
    const language = typeof document !== "undefined" ? document.documentElement.lang || "hu" : "hu";
    const path = typeof window !== "undefined" ? window.location.pathname : "/";
    // Fire-and-forget internal tracking
    axios.post(`${API}/track/event`, { event, metadata, language, path }).catch(() => {});
    // GA4 if configured
    if (GA4_ID && typeof window !== "undefined" && window.gtag) {
      window.gtag("event", event, { ...metadata, language });
    }
  } catch (_) {
    // no-op
  }
}
